import { createContext } from 'react';
import type { AuthSnapshot, LoginInput, RegisterInput } from './auth-store.js';

/**
 * Le contexte d'authentification, et rien d'autre. Même raison que `theme-context.ts` : un module
 * qui ne contient ni composant ni hook n'est jamais remplacé à chaud, donc l'identité du contexte
 * reste la même entre le fournisseur déjà monté et les consommateurs rendus après une modification.
 */

export interface AuthContextValue extends AuthSnapshot {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (input: LoginInput) => Promise<void>;
  register: (input: RegisterInput) => Promise<void>;
  logout: () => Promise<void>;
  logoutEverywhere: () => Promise<void>;
  switchOrganization: (organizationId: string) => Promise<void>;
  reloadIdentity: () => Promise<void>;
  startImpersonation: (userId: string) => Promise<void>;
  endImpersonation: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
